var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9571_11025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43294 11.5002C7.43294 10.4249 6.56028 9.55225 5.48503 9.55225C4.40978 9.55225 3.53711 10.4249 3.53711 11.5002C3.53711 12.5754 4.40978 13.4481 5.48503 13.4481C6.56028 13.4481 7.43294 12.5754 7.43294 11.5002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43294 17.1667C7.43294 16.0914 6.56028 15.2188 5.48503 15.2188C4.40978 15.2188 3.53711 16.0914 3.53711 17.1667C3.53711 18.2419 4.40978 19.1146 5.48503 19.1146C6.56028 19.1146 7.43294 18.2419 7.43294 17.1667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43294 5.83342C7.43294 4.75816 6.56028 3.8855 5.48503 3.8855C4.40978 3.8855 3.53711 4.75816 3.53711 5.83342C3.53711 6.90867 4.40978 7.78133 5.48503 7.78133C6.56028 7.78133 7.43294 6.90867 7.43294 5.83342Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94727 7.25V10.077C4.94727 10.3702 5.18527 10.6082 5.47852 10.6082C5.77177 10.6082 6.00977 10.3702 6.00977 10.077V7.25C6.00977 6.95675 5.77177 6.71875 5.47852 6.71875C5.18527 6.71875 4.94727 6.95675 4.94727 7.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95312 12.9358V15.75C4.95312 16.0432 5.19113 16.2812 5.48438 16.2812C5.77763 16.2812 6.01562 16.0432 6.01562 15.75V12.9358C6.01562 12.6425 5.77763 12.4045 5.48438 12.4045C5.19113 12.4045 4.95312 12.6425 4.95312 12.9358Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72852 7.25H14.3327C14.6259 7.25 14.8639 7.012 14.8639 6.71875C14.8639 6.4255 14.6259 6.1875 14.3327 6.1875H9.72852C9.43527 6.1875 9.19727 6.4255 9.19727 6.71875C9.19727 7.012 9.43527 7.25 9.72852 7.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72852 12.9167H14.3327C14.6259 12.9167 14.8639 12.6787 14.8639 12.3855C14.8639 12.0922 14.6259 11.8542 14.3327 11.8542H9.72852C9.43527 11.8542 9.19727 12.0922 9.19727 12.3855C9.19727 12.6787 9.43527 12.9167 9.72852 12.9167Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72852 18.5835H14.3327C14.6259 18.5835 14.8639 18.3455 14.8639 18.0522C14.8639 17.759 14.6259 17.521 14.3327 17.521H9.72852C9.43527 17.521 9.19727 17.759 9.19727 18.0522C9.19727 18.3455 9.43527 18.5835 9.72852 18.5835Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72852 5.47925H18.5827C18.8759 5.47925 19.1139 5.24125 19.1139 4.948C19.1139 4.65475 18.8759 4.41675 18.5827 4.41675H9.72852C9.43527 4.41675 9.19727 4.65475 9.19727 4.948C9.19727 5.24125 9.43527 5.47925 9.72852 5.47925Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72852 11.146H18.5827C18.8759 11.146 19.1139 10.908 19.1139 10.6147C19.1139 10.3215 18.8759 10.0835 18.5827 10.0835H9.72852C9.43527 10.0835 9.19727 10.3215 9.19727 10.6147C9.19727 10.908 9.43527 11.146 9.72852 11.146Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72852 16.8125H18.5827C18.8759 16.8125 19.1139 16.5745 19.1139 16.2812C19.1139 15.988 18.8759 15.75 18.5827 15.75H9.72852C9.43527 15.75 9.19727 15.988 9.19727 16.2812C9.19727 16.5745 9.43527 16.8125 9.72852 16.8125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9571_11025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "currentColor",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalls);
export default __webpack_public_path__ + "static/media/balls.1c827228748fd926d3e11d30aaaded89.svg";
export { ForwardRef as ReactComponent };